import { useContext, useEffect, useState, ReactNode, createContext } from 'react';
import { ServicesContext } from 'app/items/shared/context_interface';
import { usePrimitiveCollection } from 'app/agriculture/FarmMain/MapRenderer/context/PrimitiveCollectionContext';

export const BillboardCollectionContext = createContext<Cesium.BillboardCollection | null>(null);

interface CesiumCollectionProviderProps {
    children: ReactNode;
}

export function BillboardCollectionProvider({ children }: CesiumCollectionProviderProps) {
    const [collection, setCollection] = useState<Cesium.BillboardCollection | null>(null);
    const { mapService } = useContext(ServicesContext);
    const parentCollection = usePrimitiveCollection();

    useEffect(() => {
        const newCollection = parentCollection.add(
            new Cesium.BillboardCollection({ scene: mapService.viewer.scene }),
        ) as Cesium.BillboardCollection;
        setCollection(newCollection);

        return () => {
            if (!newCollection.isDestroyed()) {
                parentCollection.remove(newCollection);
            }
        };
    }, [mapService.viewer.scene, parentCollection]);

    if (!collection) return null;

    return (
        <BillboardCollectionContext.Provider value={collection}>
            {children}
        </BillboardCollectionContext.Provider>
    );
}

export function useBillboardCollection() {
    const collection = useContext(BillboardCollectionContext);
    if (!collection) throw new Error('Cesium BillboardCollection not found');
    return collection;
}
